import React from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"
import '../util/fontAwesome';
import Layout from "../components/layout"
import HeroSection from '../components/HeroSection/HeroSection';
import Section from '../components/Section/Section';
import SectionImage from '../components/SectionImage/SectionImage';
import SectionContent from '../components/SectionContent/SectionContent';
import ContactSection from '../components/ContactSection/ContactSection';
import SEO from "../components/seo"
import aboutImg from '../images/section_about.jpg';

const IndexPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
    <Helmet>
      <link href="https://fonts.googleapis.com/css?family=Titillium+Web:200,300,400,600,700,900" rel="stylesheet" type="text/css" />
    </Helmet>
    <HeroSection />
    <Section id="about" theme="dark">
      <SectionContent centered>
        <SectionImage imgUrl={aboutImg} imgAlt="About Image" />
        <br />
        <article>
          <h1>ABOUT</h1>
          <p>
            Welcome to The Melting Pot. We are a mobile catering business based in Cornwall and travel all over the south west. If you are looking for someone to cater for your birthday, wedding or... well any kind of occasion or event, look no further.
          </p>
          <p>
            With over a decade of experience in the catering industry we have a vast knowledge of food from all corners of the globe, so feel free to contact us to discuss your ideas for your occasion. We are happy to create a bespoke menu for your special event and will gladly take in to account any dietary or allergen needs.
            All of our produce is locally sourced where possible and we are committed to lowering our environmental impact by using bio-degradable and recycled food and drink containers.
          </p>
          <p>
            Please take a look at some of the dishes we can create in the <Link to="/gallery">Gallery</Link> section.
          </p>
        </article>
      </SectionContent>
    </Section>
    <ContactSection />
  </Layout>
)

export default IndexPage
